import { CSSObject } from "@mantine/core";
export const styles = () => ({
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    flexDirection: "column",
  } as CSSObject,
});
